import React, {useEffect, useState} from "react";
import {Preloader} from "components";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import {initReactI18next} from "react-i18next";
import {JSON_URL} from "modules/constants";

interface IProps {
	children: React.ReactNode;
}

export const HOCi18n: React.FC<IProps> = ({children}) => {
	const [initialized, setInitialized] = useState(false);

	useEffect(() => {
		if (window?.location?.search?.includes("skipTranslation=true")) {
			setInitialized(true);
			console.warn("Skip Translation init");
			return;
		}

		void i18n
			.use(LanguageDetector)
			.use(Backend)
			.use(initReactI18next)
			.init(
				{
					/**
					 * i18nextBrowserLanguageDetector
					 */
					detection: {
						order: ["navigator"],
					},
					backend: {
						crossDomain: true,
						loadPath: `${JSON_URL}locales/{{lng}}.json`,
					},
					supportedLngs: ["en"],
					fallbackLng: "en",
					debug: false,
					keySeparator: ".",
					interpolation: {
						escapeValue: false,
						formatSeparator: ",",
					},
				},
				() => {
					setInitialized(true);
				}
			);
	}, []);

	return initialized ? <React.Fragment>{children}</React.Fragment> : <Preloader fixed />;
};
